<template>
  <v-row no-gutters class="align-center">
    <v-col
      v-for="checkIn in checkIns"
      :key="checkIn.title"
      :class="[
        'd-flex',
        'flex-column',
        'align-center',
        isTypeEvent ? checkIn.customClass : '',
      ]"
      :cols="isTypeEvent ? 12 : 6"
    >
      <v-progress-circular
        :value="checkIn.percentage"
        :size="isTypeEvent ? 100 : 80"
        :indeterminate="dashEventLoading"
        color="primary"
        width="8"
        class="mb-2"
      >
        <strong>{{ checkIn.percentage }}%</strong>
      </v-progress-circular>
      <strong class="primary--text">{{ checkIn.value || 0 }}</strong>
      <p>{{ checkIn.title }}</p>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DashCardCheckin",
  props: {
    backgroundColor: {
      type: String,
      required: false,
      default: "base",
    },
    loading: {
      type: Boolean,
      required: false,
      default: true,
    },
    remaining: {
      type: Object,
      required: true,
      default: () => {},
    },
    achieved: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(["dashEvent", "dashEventLoading"]),
    isTypeEvent() {
      return JSON.parse(localStorage.getItem("evento")).tipo === "EVENTO";
    },
    checkIns() {
      return [
        {
          title: this.$t("producer-dashboard.achieved"),
          percentage: this.achieved.percentage,
          value: this.achieved.value,
        },
        {
          title: this.$t("producer-dashboard.remaining"),
          percentage: this.remaining.percentage,
          value: this.remaining.value,
          customClass: "mt-4",
        },
      ];
    },
  },
};
</script>

<style scoped></style>
